import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { createServiceKey, fetchAllServiceKeys } from 'js/actions';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_ALL_SERVICE_KEYS_REQUEST } from 'js/constants/actionTypes';
import { useGetServiceKeys } from 'new/components/settings/Authentication/ServiceKeys/useGetServiceKeys';

export type ServiceKeyPayload = {
  name: string;
  description: string;
};

export function useServiceKeys() {
  const [error, setError] = useState(false);
  const dispatch = useDispatch<any>();
  const serviceKeys = useGetServiceKeys();
  const isLoading = useIsLoading(GET_ALL_SERVICE_KEYS_REQUEST);

  const create = async (data: ServiceKeyPayload) => {
    if (!data) return null;
    try {
      const response = await dispatch(createServiceKey(data));
      if (response.result) {
        load();
      }
    } catch (e) {
      setError(e);
    }
  };

  const load = () => {
    try {
      const action = fetchAllServiceKeys();
      dispatch(action);
    } catch (e) {
      setError(e);
      console.error(`Error at fetchAllServiceKeys: ${e}`);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return { data: serviceKeys, error, isLoading, load, create };
}
